import { Rettungspunkte } from "@/backend_controller/rettungspunkte";

export class RettungspunkteController {
    konvKey;
    mapRef;
    bounds;
    feuerwehrID;
    partnerFeuerwehren;
    alleRettungspunkte = [];
    aktiveRettungspunkte = [];

    constructor(konvKey, mapRef, feuerwehrID, partnerFeuerwehren){
        this.konvKey = konvKey;
        this.mapRef = mapRef;
        this.feuerwehrID = feuerwehrID;
        this.partnerFeuerwehren = partnerFeuerwehren;
    }

    async init(aenderungszeitpunkt){
        await this.loadRettungspunkte(aenderungszeitpunkt);
        this.saveRettungspunkteInRadius(15);
    }

    getRettungspunkteInBounds(bounds){
        let padding = 0.01; // ca. 1000m Puffer
        const nord = bounds._northEast.lng + padding;
        const ost = bounds._northEast.lat + padding;
        const sued = bounds._southWest.lng - padding;
        const west = bounds._southWest.lat - padding;
        console.log("Bounds mit Puffer:", { nord, ost, sued, west });

        this.aktiveRettungspunkte = this.alleRettungspunkte.filter(rettungspunkt => {
            return rettungspunkt.position.x >= sued && rettungspunkt.position.x <= nord && rettungspunkt.position.y >= west && rettungspunkt.position.y <= ost;
        });

        console.log("Aktive Rettungspunkte in Bounds:", this.aktiveRettungspunkte);
        console.log(this.alleRettungspunkte);
    }

    async loadRettungspunkte(aenderungszeitpunkt){
        let response = await Rettungspunkte.get();
        if(response){
            this.alleRettungspunkte = response;
            //localStorage.setItem("rettungspunkte", JSON.stringify(this.alleRettungspunkte));
            localStorage.setItem("aenderungszeitpunktRettungspunkt", aenderungszeitpunkt);
        } else {
            this.alleRettungspunkte = JSON.parse(localStorage.getItem("rettungspunkte"));
        }
    }

    saveRettungspunkteInRadius(radiusKm){
        if (!this.mapRef) return;
        console.log(this.mapRef);
        const center = this.mapRef.center;
        console.log("Kartenmittelpunkt:", center);
        const centerLat = center[0];
        const centerLng = center[1];

        const rettungspunkteImRadius = this.alleRettungspunkte.filter(rp => {
            const distance = this.calculateDistance(
                centerLat,
                centerLng,
                rp.position.y, // latitude
                rp.position.x  // longitude
            );
            return distance <= radiusKm;
        });

        localStorage.setItem(
            "rettungspunkte",
            JSON.stringify(rettungspunkteImRadius)
        );

        console.log("Gespeicherte Rettungspunkte (5km):", rettungspunkteImRadius);
    }

    calculateDistance(lat1, lon1, lat2, lon2){
        const R = 6371; // Erdradius in km
        const dLat = this.toRad(lat2 - lat1);
        const dLon = this.toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.toRad(lat1)) *
            Math.cos(this.toRad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    toRad(value){
        return (value * Math.PI) / 180;
    }
}